import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getSessionTimeline = async (focusGroupId) => {
    const { data } = await vlqrApi.get(`reports/${focusGroupId}/SessionTimeline`)
        .catch((error) => {
            handleError(error);
        });
    return data;
};

const useSessionTimeline = (focusGroupId) => {
    const { data, isLoading, isError } = useQuery({
        queryKey: ['sessionTimeline', focusGroupId],
        queryFn: () => getSessionTimeline(focusGroupId),
        enabled: Boolean(focusGroupId)
    });

    return { data, isLoading, isError };
};

export default useSessionTimeline;
